import { object } from 'yup'
import { MultiStepSchema } from 'components/Wizards/schemas/Types'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { designProject } from 'components/Wizards/schemas/shared/designProject'
import { designTopic } from 'components/Wizards/schemas/shared/designTopic'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { language } from 'components/Wizards/schemas/shared/language'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { crossPostAccounts } from 'components/Wizards/schemas/shared/crossPostAccounts'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { meta } from '../schemaCommon'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { array, string } from 'yup'

export const FlowCSchema = ({ generationType }: { generationType: string }) => {
  const RefinePostDetails = object({
    topic: designTopic
      .meta({
        label: `What is it about?`,
        generate: false,
        generationType,
      })
      .required(),
    brand_kit_id: brandKitId,
    tone: tone.optional().meta({ generationType }),
    filename,
    project: designProject,
    language,
    cross_post_accounts: crossPostAccounts,
  }).meta({
    title: 'Refine post details',
  })

  const PickImage = object({
    selected_images: array().of(string()).default([]).transform(safify),
    featured_selected_images: array().of(string()).default([]).transform(safify),
  }).meta({
    title: 'Pick an image',
    supportedMediaTypes: ['image'],
    showMediaLibrary: true,
    submitLabel: 'Create Post',
  })

  return {
    meta,
    steps: [RefinePostDetails, PickImage],
  } as MultiStepSchema<ChannelType>
}
